export const STORAGE_KEY_URL_QUERIES = 'url_queries'
export const STORAGE_KEY_PENDING_REDIRECT = 'purple_pending_redirect'
